import * as React from "react";
import Rating from "@mui/material/Rating";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";

export default function CluppRating({
  labels,
  rating,
  field,
  title = null,
  setState,
  Icon,
  max = 5,
  fillIconColor = "#00BBEE",
  size = "35px",
  precision = 1,
  haveNumbers = false,
  iconContainerComponent = null,
  activeLabels= true
}) {
  const [hover, setHover] = React.useState(-1);

  function getLabelText(value) {
    return `${value} Star${value !== 1 ? "s" : ""}, ${labels[value]}`;
  }

  const handleChange = (newValue) => {
    if (newValue) {
      setState((prev) => ({
        ...prev,
        [field]: {
          value: newValue,
          label: labels[hover !== -1 ? hover : newValue],
        },
      }));
    }
  };

  const IconContainerComponent = ({ children, value }) =>
    iconContainerComponent ? (
      iconContainerComponent
    ) : (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {children}
        <Typography>{value}</Typography>
      </Box>
    );

  const value = rating?.value;
  return (
    <Box
      sx={{
        margin: "20x 0px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
      }}
    >
      {title && (
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          {title}
        </Typography>
      )}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Rating
          name="hover-feedback"
          value={value}
          precision={precision}
          size="large"
          max={max}
          getLabelText={getLabelText}
          onChange={(event, newValue) => handleChange(newValue)}
          onChangeActive={(event, newHover) => {
            setHover(newHover);
          }}
          IconContainerComponent={
            haveNumbers ? IconContainerComponent : undefined
          }
          icon={<Icon sx={{ color: fillIconColor, fontSize: size }} />}
          emptyIcon={
            <Icon sx={{ color: "#CCCCCC", opacity: 0.55, fontSize: size }} />
          }
        />
        {value !== null && activeLabels && (
          <Box sx={{ ml: 2, fontWeight: 600 }}>
            {labels[hover !== -1 ? hover : value]}
          </Box>
        )}
      </Box>
    </Box>
  );
}
